import Swiper from '../../../../node_modules/swiper/swiper-bundle.mjs';

export const initSliderProduct = function () {
  const btnPrewNext = document.querySelector('[data-slider-product="arrow-next-prew"]');
  const btnPrewPrev = document.querySelector('[data-slider-product="arrow-prev-prew"]');
  const btnNext = document.querySelector('[data-slider-product="arrow-next"]');
  const btnPrev = document.querySelector('[data-slider-product="arrow-prev"]');
  const sliderProductPrew = document.querySelector('[data-slider-product="slider-prew"]');
  const sliderProduct = document.querySelector('[data-slider-product="slider"]');
  if (!sliderProduct) {
    return;
  }
  const swiperProduct = function () {
    const sliderProdPrew = new Swiper(sliderProductPrew, {
      loop: true,
      spaceBetween: 10,
      slidesPerView: 5,
      freeMode: true,
      watchSlidesProgress: true,
    });

    const sliderProd = new Swiper(sliderProduct, {
      loop: true,
      navigation: {
        nextEl: '[data-slider-product="arrow-next"]',
        prevEl: '[data-slider-product="arrow-prev"]',
      },
      thumbs: {
        swiper: sliderProdPrew,
      },
    });

    const customClickBtn = function (el) {
      const event = new CustomEvent('click');
      el.dispatchEvent(event);
    }
    if (btnPrewNext) {
      btnPrewNext.addEventListener('click', function (evt) {
        evt.preventDefault();
        customClickBtn(btnNext);
      });
    }
    if (btnPrewPrev) {
      btnPrewPrev.addEventListener('click', function (evt) {
        evt.preventDefault();
        customClickBtn(btnPrev);
      });
    }
  }
  swiperProduct();
};
